<template>
  <v-container fluid id="page-profile">

  <v-layout>
    <v-flex xs3 class="first-col">
      <h1> <v-icon>mdi-account-circle</v-icon> {{$t('titles.account')}}</h1>
    </v-flex>
    <v-flex xs7 class="contain-fields">
      <itt-profile-field v-for="field in profileFields" :key="field.key" :field="field" :data-profile="profile"/>
      <!-- pas dispo :  -->
      <!-- <itt-profile-field :data-profile="{type: 'Company', value: 'Molengeek'}" />
      <itt-profile-field :data-profile="{type: 'Subscription', value: 'Pack Premium'}" />
      <itt-profile-field :data-profile="{type: 'Analyzes', value: '67'}" /> -->

    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import ittProfileField from "@/components/user/profile-field.vue"
export default {
  components: {
    ittProfileField
  },
  beforeCreate() {
    let userInfo = this.$store.dispatch('users/getUser');
    let consom = this.$store.dispatch('users/getConsom');
    this.$store.dispatch('users/getProfile').then(async (profile) => {
      consom = await consom;
      profile.consom = consom.count;
      userInfo = await userInfo;
      profile.email = userInfo.email;
      profile.first_name = userInfo.first_name;
      profile.last_name = userInfo.last_name;
      profile.username = userInfo.username;
      this.profile = profile;
      this.profileFields = [
        // {label:'Company' , key:'organisation', from:'profile'}, // UUID
        {label:this.$t('texts.jobTitle'), keyLang: 'jobTitle', key:'job_title', from:'profile'},
        {label: this.$t('texts.jobDescription'), keyLang: 'jobDescription', key:'job_description', from:'profile'},
        {label: this.$t('texts.firstName'), keyLang: 'firstName', key:'first_name', from:'user'},
        {label: this.$t('texts.lastName'), keyLang: 'lastName', key:'last_name', from:'user'},
        {label: this.$t('texts.userName'), keyLang: 'userName', key:'username', from:'user', readonly: true},
        {label: this.$t('texts.email'), keyLang: 'email', key:'email', from:'user', readonly:true}, // readonly
        {label: this.$t('texts.phone'), keyLang: 'phone', key:'phone', from:'profile'},
        {label: this.$t('texts.address'), keyLang: 'address', key:'adress', from:'profile'},
        {label: this.$t('texts.language'), keyLang: 'language', key:'language', from:'profile'},
        {label: this.$t('texts.accountLevel'), keyLang: 'accountLevel', key:'account_level', from:'', readonly: true},
        {label: this.$t('texts.consomation'), keyLang: 'consomation', key:'consom', from:'', readonly: true},
        // 'Subscription', 
        // 'Analyzes'
        ]
    });
  },
  computed: {
    language() {
      if (this.$store.getters['users/getProfile'])
        return this.$store.getters['users/getProfile'].language || 'EN';
      return 'EN';
    }
  },
  watch: {
    language(lang) {
      this.profileFields.forEach(field => {
        field.label = this.$t('texts.' + field.keyLang);
      })
    }
  },
  data() {
    return {
      profile: null,
      profileFields: []
    }
  }
}
</script>

<style lang="sass" scoped>
#page-profile 
  .contain-fields, .first-col
    margin-top: 2rem
  .first-col 
    h1
      color: white !important
      height: 5.4rem
      margin: 0
      display: flex
      align-items: center
      justify-content: center
      i 
        font-size: 2.5rem
  .contain-fields
</style>
